/**
 * Pure decision logic for whether a batch's recipient count fits within Microsoft's rolling
 * 10,000-recipients/24h mailbox limit -- factored out of taskpane.js so it's unit-testable
 * without Office.js/DOM. Used both for Step 4's live readout (refreshQuota) and the
 * whole-batch preflight right before a send starts (runBatch) -- see taskpane.js. This is UX
 * only; the server enforces the real limit independently in /run, so this fails open (never
 * blocks) when `remaining` itself couldn't be determined -- callers only invoke it once they
 * already have a `remaining` figure from GET /api/quota.
 */
export function evaluateRecipientQuota(batchRecipients, remaining) {
  const exceeds = batchRecipients > remaining;
  return {
    exceeds,
    message: exceeds
      ? `This batch needs ${batchRecipients.toLocaleString()} recipients, but only ${remaining.toLocaleString()} ` +
        `are left of Microsoft's 10,000/24h mailbox limit. Trim the recipient list, or try again later.`
      : null,
  };
}
